import { IClientData, IVehicleData } from '../../../createAndEdit/types';

interface IDetailVehicleAndClientCardsMobileProps {
  vehicleData?: IVehicleData;
  clientData?: IClientData;
}

const DetailVehicleAndClientCardsMobile = (props: IDetailVehicleAndClientCardsMobileProps) => {
  return (
    <div className="flex flex-col gap-4 mb-6 px-4 items-stretch">
      {props.vehicleData && (
        <div className="flex-1 flex flex-col">
          <div className="font-bold mb-2">Veículo</div>
          <div className="border border-gray-200 dark:border-neutral-700 rounded-md p-4 h-full">
            <div className="rounded-md p-4 h-full bg-[#E5EBF0] dark:bg-neutral-800">
              <div className="flex flex-col items-start gap-4">
                <div className="bg-white dark:bg-neutral-900 rounded-md flex items-center justify-center shrink-0 w-12 h-12">
                  <img src="/assets/images/truck.svg" alt="Veículo" className="w-6 h-6 dark:invert" />
                </div>
                <div className="flex-1 w-full">
                  {props.vehicleData && (
                    <div className="text-size-14">
                      {props.vehicleData.model && (
                        <div className="font-bold">
                          {props.vehicleData.model}
                          {props.vehicleData.year && ` ${props.vehicleData.year}`}{' '}
                          {props.vehicleData.licensePlate &&
                            ` | Placa: ${props.vehicleData.licensePlate}`}
                        </div>
                      )}
                      {props.vehicleData.chassis && (
                        <div className="mt-1">Chassi - {props.vehicleData.chassis}</div>
                      )}
                      {(props.vehicleData.odometer || props.vehicleData.hourmeter) && (
                        <div className="mt-1">
                          {props.vehicleData.odometer && `Odômetro: ${props.vehicleData.odometer}`}
                          {props.vehicleData.odometer && props.vehicleData.hourmeter && ' | '}
                          {props.vehicleData.hourmeter && `Horímetro: ${props.vehicleData.hourmeter}`}
                        </div>
                      )}
                      {props.vehicleData.contractNumber && (
                        <div className="mt-1 font-bold">
                          Volks total Prev: Contrato #{props.vehicleData.contractNumber}
                        </div>
                      )}
                    </div>
                  )}
                </div>
                {props.vehicleData?.inWarranty && (
                  <div className="relative top-0 right-0 mt-2">
                    <span className="inline-block bg-green-100 dark:bg-green-900/40 text-green-800 dark:text-green-300 px-3 py-1 rounded-full text-size-12 font-bold whitespace-nowrap">
                      Em garantia
                    </span>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      {props.clientData && (
        <div className="flex-1 flex flex-col">
          <div className="font-bold mb-2">Cliente</div>
          <div className="border border-gray-200 dark:border-neutral-700 rounded-md p-4 h-full">
            {props.clientData && (
              <div className="text-size-14 h-full">
                {props.clientData.name && (
                  <div className="font-bold mb-2">{props.clientData.name}</div>
                )}
                <div className="flex flex-col gap-1">
                  <div>{props.clientData.phone || ''}</div>
                  <div>{props.clientData.email || ''}</div>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default DetailVehicleAndClientCardsMobile;
